import { render, staticRenderFns } from "./PutDistrictList.vue?vue&type=template&id=57738ab4&scoped=true"
import script from "./PutDistrictList.vue?vue&type=script&lang=js"
export * from "./PutDistrictList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57738ab4",
  null
  
)

export default component.exports